export default __webpack_public_path__ + "static/media/arrow_left.ee9d27d9.svg";